import React from 'react'
import { motion } from "framer-motion";

import banner from '../banner-pic.png'
import CustomerList from '../component/CustomerList';
import { Link } from 'react-router-dom';


export default function HeroBanner() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-[#12253c] to-[#172f47] py-16 sm:py-20 lg:py-28 px-4 sm:px-6 lg:px-8 ">

      {/* Overlay Glow */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-white/10 backdrop-blur-sm"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative pt-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 items-center">

          {/* LEFT CONTENT */}
          <div className="text-center lg:text-left">

            {/* Badge */}
            

            {/* Heading */}
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl  text-white mb-4 sm:mb-6 font-semibold" style={{lineHeight:'50px'}}>
              Lend smarter. Grow faster. Win with AI-driven credit infrastructure
              {/* <span className="bg-gradient-to-r from-white to-emerald-300 bg-clip-text text-transparent mt-4">
                AI-powered solutions built  for banks & NBFCs
              </span> */}
            </h1>

            {/* Description */}
            <p className="text-sm sm:text-base md:text-base text-white/80 mb-8 leading-relaxed pt-3">
              LNVSTech transforms digital lending with smart technology solutions that automate onboarding, verification, risk evaluation, and loan processing, helping financial institutions deliver faster, safer, and more efficient credit experiences. </p>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start pt-5">
              <Link to={'/contact'}>
                <button className="bg-[#0fce84] text-white px-6 py-3 rounded-full font-medium hover:scale-105 transition">
                  Book a Demo
                </button>
              </Link>

              <Link to={'/product'}>
                <button className="bg-white/10 backdrop-blur-md border border-white/30 text-white px-6 py-3 rounded-full hover:bg-white/20 transition">
                  Explore Products
                </button>
              </Link>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="flex justify-center lg:justify-end relative">
            {/* Main Image */}
            <div className="relative animate-float">
              <img src={banner} alt="finance" className="" /> </div>


          </div>

        </div>

        {/* ANIMATION */}
        <style>{`
    @keyframes float {
      0%,100% { transform: translateY(0); }
      50% { transform: translateY(-12px); }
    }
    .animate-float {
      animation: float 5s ease-in-out infinite;
    }
  `}</style>

        {/* <CustomerList/> */}


      </div>

    </section>
  )
}
